import { render, staticRenderFns } from "./Poll.vue?vue&type=template&id=0bc97a47&scoped=true"
import script from "./Poll.vue?vue&type=script&lang=ts"
export * from "./Poll.vue?vue&type=script&lang=ts"
import style0 from "./Poll.vue?vue&type=style&index=0&id=0bc97a47&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc97a47",
  null
  
)

export default component.exports